module.exports = __webpack_public_path__ + "static/media/case4.5e727cf4.jpg";